import { Typography } from '@workspace/ui/components/Typography';
import { cn } from '@workspace/ui/lib/utils';
import { observer } from 'mobx-react-lite';
import type React from 'react';
import { useRef } from 'react';
import { company } from '~/company/Company';

import { DeliveryTimeWarning } from '~/components/HeaderV3/components/DeliveryTimeWarning';
import Icon from '~/components/Icon/Icon';
import { IconButton } from '~/components/isolated/IconButton';
import { useCartButton } from '~/hooks/useCartButton';

export const CartButton = observer<
  Omit<React.ComponentPropsWithoutRef<'div'>, 'children'>
>(({ className, ...props }) => {
  const buttonRef = useRef<HTMLDivElement>(null);
  const { cartBadgeLabel, handleNavigateCart } = useCartButton();

  return (
    <div {...props} className={cn('relative', className)} ref={buttonRef}>
      <IconButton
        variant="brand"
        size="L"
        onClick={handleNavigateCart}
        data-button="header-cart"
      >
        <Icon type="cart-3.1" width={18} height={17} />
        {cartBadgeLabel && (
          <div className="pointer-events-none absolute -top-[5px] -right-[4px] flex h-6 w-6 flex-row items-center justify-center rounded-full bg-icon-white shadow-[0_0_0_1.4px_rgba(45,47,51,0.17)]">
            <Typography.Text200Semibold
              as="span"
              className={company.match({
                mcosmetic: 'text-text-brand',
                ocado: 'text-text-brand',
                default: 'text-graphic-regular-black',
              })}
            >
              {cartBadgeLabel}
            </Typography.Text200Semibold>
          </div>
        )}
      </IconButton>
      <DeliveryTimeWarning buttonRef={buttonRef} />
    </div>
  );
});
CartButton.displayName = 'CartButton';
